import React, { useEffect, useState } from "react";
import axios from "axios";

export default function OrdersAdmin() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await axios.get("https://api.speedfollowinfo.com/api/admin/orders");
        if (res.data.success) setOrders(res.data.orders);
      } catch (err) {
        console.error("❌ Error fetching orders:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  if (loading)
    return (
      <div className="text-center text-gray-400 mt-10 animate-pulse">
        Loading Completed / Cancelled Orders...
      </div>
    );

  return (
    <div className="min-h-screen bg-[#0b0f1a] text-white p-6 md:p-10">
      <h1 className="text-2xl font-bold mb-6 text-[#f2a900]">
        📦 Completed / Cancelled Orders
      </h1>

      <div className="overflow-x-auto rounded-lg border border-gray-800 shadow-lg">
        <table className="w-full border-collapse text-left">
          <thead className="bg-[#111827] text-[#f2a900] uppercase text-sm">
            <tr>
              <th className="p-3 border-b border-gray-700">#</th>
              <th className="p-3 border-b border-gray-700">Username</th>
              <th className="p-3 border-b border-gray-700">Email</th>
              <th className="p-3 border-b border-gray-700">Category</th>
              <th className="p-3 border-b border-gray-700">Service</th>
              <th className="p-3 border-b border-gray-700">Price</th>
              <th className="p-3 border-b border-gray-700">Status</th>
              <th className="p-3 border-b border-gray-700">Date</th>
            </tr>
          </thead>

          <tbody>
            {orders.length === 0 ? (
              <tr>
                <td
                  colSpan="8"
                  className="text-center text-gray-400 py-6 italic"
                >
                  No completed or cancelled orders found
                </td>
              </tr>
            ) : (
              orders.map((order, index) => {
                const username = order.user?.username || "Unknown User";
                const email = order.user?.email || "—";
                const isComplete = order.status === "Complete";
                const isCancelled = order.status === "Cancelled";

                return (
                  <tr
                    key={order._id}
                    className="hover:bg-[#1b2138] transition border-b border-gray-800"
                  >
                    <td className="p-3 text-gray-400">
                      #{order.orderNumber || index + 1}
                    </td>
                    <td className="p-3 font-semibold">{username}</td>
                    <td className="p-3 text-gray-400">{email}</td>
                    <td className="p-3 text-[#f2a900] font-medium">
                      {order.categoryType || "—"}
                    </td>
                    <td className="p-3 text-gray-300">
                      {order.service || "—"}
                    </td>
                    <td className="p-3 text-[#ffd700] font-semibold">
                      ৳{order.price?.toFixed(2)}
                    </td>
                    <td
                      className={`p-3 font-bold text-center rounded-lg ${
                        isComplete
                          ? "text-green-400 bg-green-900/30 border border-green-600/40"
                          : isCancelled
                          ? "text-red-400 bg-red-900/30 border border-red-600/40"
                          : "text-yellow-400"
                      }`}
                    >
                      {order.status}
                    </td>
                    <td className="p-3 text-gray-400">
                      {new Date(order.createdAt).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}